import { useRef } from 'react'
import type { BaseCursorPagingRef } from 'src/components/CursorPaging/BaseCursorPaging'
import BaseCursorPaging from 'src/components/CursorPaging/BaseCursorPaging'
import Empty from 'src/components/Empty'
import Text from 'src/components/ui/Text'
import { useUserProfileContext } from 'src/components/UserProfile/UserProfile.context'
import {
  useListActiveCollectionCardSets,
  useListUserCollectionCardSetProgress,
  useListUserCollectionCards,
} from 'src/services/apollo/user'
import { useQs } from 'src/utils/qs'
import { CollectionCardSetWithProgressItem } from './CollectionCardSetItem'

/**
 * This component should be used within UserProfile
 * Since it relies on UserProfile context
 * To determine current user
 * @returns
 */
export function CollectionCardPaginatedList() {
  const { user } = useUserProfileContext()
  const [{ before, after }, setQs] = useQs()
  const pagingRef = useRef<BaseCursorPagingRef>(null)

  return (
    <BaseCursorPaging
      useSWR={useListUserCollectionCardSetProgress}
      getConnection={r => r}
      pageSize={20}
      renderItem={it => {
        return (
          <CollectionCardSetWithProgressItem
            key={it.id}
            collectionCardSetProgress={it}
            onRefetch={pagingRef.current?.mutate}
          />
        )
      }}
      renderContainer={({ children }) => (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] gap-x-4 gap-y-8 py-2">
          {children}
        </div>
      )}
      pagingRef={pagingRef}
      empty={
        <Empty
          description={
            <Text
              i18nKey={`user:user-decoration.collection-card.list-empty-placeholder`}
            />
          }
        />
      }
      extraArgs={{
        userId: user?.id,
      }}
      before={before}
      after={after}
      onCursorChange={setQs}
    />
  )
}
